import { render } from "./CardStandard.component.vue?vue&type=template&id=2f838cba"
import script from "./CardStandard.component.vue?vue&type=script&lang=js"
export * from "./CardStandard.component.vue?vue&type=script&lang=js"

import "./CardStandard.component.vue?vue&type=style&index=0&id=2f838cba&lang=scss"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/searchFind/cardType/CardStandard.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f838cba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f838cba', __exports__)) {
    console.log('reload')
    api.reload('2f838cba', __exports__)
  }
  
  module.hot.accept("./CardStandard.component.vue?vue&type=template&id=2f838cba", () => {
    console.log('re-render')
    api.rerender('2f838cba', render)
  })

}


export default __exports__